import React from 'react';
import { Col, Row } from "react-bootstrap";
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import './FAQ.scss';

function buildList(list, index) {
  return (
    <ul key={index}>
      {list.map((listItem, i) => Array.isArray(listItem) ?
        buildList(listItem, i) :
        <li key={i}>{listItem}</li>
      )}
    </ul>
  );
}

function FAQCard(props) {
  return (
    <Row className='expansionDiv'>
      <ExpansionPanel className="expansion-panel" square>
        <ExpansionPanelSummary
          expandIcon={<KeyboardArrowDownIcon />}
          aria-controls="panel1-content"
          id={props.index}
          className={props.showExpandIconAtLeft ? "expansion-panel-summary px-0" : 'px-0'}
        >
          <span className="question pl-2"><strong>{props.question}</strong></span>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className="p-0">
          <div className={props.showExpandIconAtLeft ? "leftIconAnswer" : "answer"}>
            {props.answer.map((paragraph, i) => Array.isArray(paragraph) ?
              buildList(paragraph, i)
              : <p key={i} dangerouslySetInnerHTML={{ __html: paragraph }}></p>)}
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </Row>
  )
}

export default function FAQs(props) {

  const faqData = props.data;
  return (
    <React.Fragment>
      {faqData && (
        <div id="faq" className="faq-section">
          <Row>
            <Col className="content-section">
              <Row>
                <h2 className="mb-3 product-title">Frequently Asked Questions</h2>
              </Row>
              {faqData.map((faq, index) => <FAQCard showExpandIconAtLeft={props.showExpandIconAtLeft} key={index} index={index} question={faq.title} answer={faq.text} />)}
            </Col>
          </Row>
        </div>
      )}
    </React.Fragment>

  );
};


// WEBPACK FOOTER //
// ./src/components/ProductLanding/FAQs.js